var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[(_vm.courseName && _vm.courseName.substr(0,1)=='【')?_c('i',{staticClass:"title-special-processing"}):_vm._e(),_vm._v(_vm._s(_vm.courseName))]),(_vm.brief)?_c('h3',[_vm._v(_vm._s(_vm.brief))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }